export default "__VITE_ASSET__DDGHn05C__"